<script>
  import Grid from 'svelte-grid';
  import GridItem from './GridItem.svelte';
  import CreateItemDialog from './dialogs/builder/CreateItemDialog.svelte';
  import PreviewGridDialog from './dialogs/builder/PreviewGridDialog.svelte';
  import CodeEditor from './CodeEditor.svelte';
  import { generateItems, items, handleSubmitAction } from '../utils.js';
  import { onMount, createEventDispatcher, tick } from 'svelte';
  import { getGrid, saveGridConfig } from '../api';

  export let data;
  let grid = { name: '', custom_css: '// add css here', mobile: { items: [] }, desktop: { items: [] } };
  const cols = [[1000, 4]];
  let rowHeight = 265;

  const dispatch = createEventDispatcher();
  const back = () => {
    dispatch('back');
  };
  const deleteItem = (e) => {
    console.log(e.detail);
    handleSubmitAction(e.detail);
  };
  const submitDialog = async (e) => {
    if (e.detail.includeOnMobile) {
      handleSubmitAction({ ...e.detail, device: 'mobile', size: 4 });
    }

    if (e.detail.includeOnDesktop) {
      handleSubmitAction({ ...e.detail, device: 'desktop' });
    }
  };
  const submitConfig = (e) => {
    saveGridConfig(data.id, grid.name, grid.custom_css, false);
    back();
  };

  let mounted = false;
  onMount(async () => {
    grid = await getGrid(data.id);
    let devices = ['mobile', 'desktop'];
    let itemData = {};

    console.log(grid);
    devices.forEach((device) => {
      itemData[device] = grid[device].items;
      itemData[device].map((item) => {
        if (device == 'mobile') item.size = 4;
      });
    });
    generateItems(itemData);
    mounted = true;
  });
</script>

<header>
  <h1>
    <button on:click={back}
      ><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 17L1 9L9 1" stroke="#091EB5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    Editing: {grid.name}
  </h1>
  <div>
    <CreateItemDialog on:submit={submitDialog} />
    <PreviewGridDialog on:submit={submitConfig} data={{ id: grid.id, name: grid.name, css: grid.custom_css }} />
  </div>
</header>

<div class="demo-wrapper " style="--rowHeight:{rowHeight}px">
  {#if mounted}
    <div class="sb-desktop demo-container ">
      <span>Desktop view</span>
      <Grid bind:items={$items.desktop} {rowHeight} let:item let:dataItem fastStart={true} {cols}>
        <GridItem on:delete={deleteItem} on:edit={submitDialog} {dataItem} />
      </Grid>
    </div>
    <div class="sb-mobile demo-container ">
      <span>Mobile view</span>
      <Grid bind:items={$items.mobile} {rowHeight} let:item let:dataItem fastStart={true} {cols}>
        <GridItem on:delete={deleteItem} on:edit={submitDialog} {dataItem} mobile={true} />
      </Grid>
    </div>
  {/if}
</div>

{#if mounted}
  <CodeEditor text={grid.custom_css} on:update={(e) => (grid.custom_css = e.detail)} lang="css" saveDisabled={true} />
{/if}

<style>header{align-items:center;background-color:#fff;display:flex;justify-content:space-between;left:0;padding:1em 0;position:-webkit-sticky;position:sticky;right:0;top:0;z-index:222}.demo-wrapper{border-radius:2px;display:grid;gap:2em;grid-template-columns:1fr 400px;margin-bottom:2em;min-height:calc(var(--rowHeight)*2);overflow:hidden;width:100%}.demo-container{padding:.5em}.sb-desktop,.sb-mobile{background-color:#f0f8ff}:global(.device-selectors .checkbox-wrapper){margin-bottom:0!important;margin-top:8px}:global(.device-selectors .checkbox-wrapper input){margin-bottom:0!important;padding:4px!important}</style>
